import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0eafbcc4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "btns-wrap" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 导入 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 备份 ")
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "example",
  src: "https://gw.alipayobjects.com/zos/rmsportal/JiqGstEfoWAOHiTxclqi.png"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_8 = { class: "form-wrap" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://blog.zht87.com/archives/36/",
  target: "_blank",
  rel: "noopener noreferrer"
}, "Cookies获取教程", -1))
const _hoisted_10 = { class: "btns" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("测试Cookies")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 选择文件内包含")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("条支持导入的数据，导入时会覆盖已存在的站点数据，是否确定导入？ ")
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "文件内包含cookie站点如下（仅列出PT管理宝支持的站点）：", -1))
const _hoisted_15 = { class: "result-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_download_outlined = _resolveComponent("download-outlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_upload_outlined = _resolveComponent("upload-outlined")!
  const _component_edit_outlined = _resolveComponent("edit-outlined")!
  const _component_delete_outlined = _resolveComponent("delete-outlined")!
  const _component_a_card_meta = _resolveComponent("a-card-meta")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_plus_outlined = _resolveComponent("plus-outlined")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_page_container = _resolveComponent("page-container")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_drawer = _resolveComponent("a-drawer")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_page_container, {
      title: "设置站点Cookie",
      "sub-title": "支持拖拽排序"
    }, {
      tags: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_a_upload, {
            "before-upload": _ctx.beforeUpload,
            showUploadList: false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, null, {
                default: _withCtx(() => [
                  _createVNode(_component_download_outlined),
                  _hoisted_2
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["before-upload"]),
          _createVNode(_component_a_button, {
            style: {"margin-left":"20px"},
            onClick: _ctx.exportHandle
          }, {
            default: _withCtx(() => [
              _createVNode(_component_upload_outlined),
              _hoisted_3
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_draggable, {
            modelValue: _ctx.stationList,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.stationList) = $event)),
            group: "station",
            onStart: _ctx.dragStart,
            onEnd: _ctx.dragEnd,
            "item-key": "id",
            class: "ant-row",
            style: {"margin-left":"-8px","margin-right":"-8px","row-gap":"0px"}
          }, {
            item: _withCtx(({ element }) => [
              _createVNode(_component_a_col, {
                xs: 24,
                sm: 12,
                md: 8,
                lg: 6,
                xl: 4,
                style: {"margin-bottom":"20px","padding-left":"8px","padding-right":"8px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_card, {
                    hoverable: "",
                    onClick: ($event: any) => (_ctx.editStationHandle(element))
                  }, {
                    cover: _withCtx(() => [
                      _createElementVNode("img", {
                        alt: "example",
                        src: 
                    element.icon ||
                    'https://gw.alipayobjects.com/zos/rmsportal/JiqGstEfoWAOHiTxclqi.png'
                  
                      }, null, 8, _hoisted_4)
                    ]),
                    actions: _withCtx(() => [
                      _createVNode(_component_edit_outlined, { key: "edit" }),
                      _createVNode(_component_delete_outlined, {
                        key: "delete",
                        onClick: _withModifiers(($event: any) => (_ctx.delStationHandle(element)), ["stop"])
                      }, null, 8, ["onClick"])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_card_meta, {
                        title: element.remark
                      }, null, 8, ["title"])
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }, 8, ["modelValue", "onStart", "onEnd"]),
          _createVNode(_component_a_row, { gutter: 16 }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_component_a_col, {
                xs: 24,
                sm: 12,
                md: 8,
                lg: 6,
                xl: 4,
                key: 99999999
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_card, {
                    hoverable: "",
                    onClick: _ctx.showDrawer
                  }, {
                    cover: _withCtx(() => [
                      _hoisted_5
                    ]),
                    actions: _withCtx(() => [
                      _createVNode(_component_plus_outlined, { key: "edit" })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_card_meta, { title: "添加站点" })
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }))
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_a_drawer, {
      title: "设置站点信息",
      placement: "bottom",
      visible: _ctx.visible,
      closable: false,
      maskClosable: false,
      height: "60%",
      onClose: _ctx.closeDrawer
    }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_button, {
          style: {"margin-right":"8px"},
          disabled: _ctx.submitLoading,
          onClick: _ctx.closeDrawer
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        _createVNode(_component_a_button, {
          type: "primary",
          disabled: _ctx.submitLoading,
          loading: _ctx.submitLoading,
          onClick: _ctx.sumbitHandle
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["disabled", "loading", "onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_a_form, {
            ref: "formEle",
            model: _ctx.formState,
            rules: _ctx.rules
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, { name: "code" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    placeholder: "请选择站点",
                    value: _ctx.formState.code,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.code) = $event)),
                    onChange: _ctx.stationChange
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.canSelectStationOptions, (option) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          value: option.code,
                          key: option.code,
                          option: option,
                          disabled: option.disabled
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(option.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["value", "option", "disabled"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value", "onChange"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { name: "name" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    placeholder: "请输入备注",
                    autocomplete: "",
                    value: _ctx.formState.name,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.name) = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { name: "cookie" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_textarea, {
                    class: "input-cookie",
                    value: _ctx.formState.cookie,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.cookie) = $event)),
                    placeholder: "请将站点对应的Cookie粘贴至此处",
                    "allow-clear": ""
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"]),
          _hoisted_9
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_a_button, {
            type: "primary",
            loading: _ctx.checkCookieLoading,
            onClick: _ctx.checkCookiesHandle
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          }, 8, ["loading", "onClick"])
        ])
      ]),
      _: 1
    }, 8, ["visible", "onClose"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.importResultVisible,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.importResultVisible) = $event)),
      title: "导入结果",
      "confirm-loading": _ctx.importLoading,
      cancelText: "取消",
      okText: "确定",
      destroyOnClose: true,
      maskClosable: false,
      onOk: _ctx.handleImport
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", null, [
          _hoisted_12,
          _createElementVNode("b", null, "[" + _toDisplayString(_ctx.importResultData.length) + "]", 1),
          _hoisted_13
        ]),
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("b", null, _toDisplayString(_ctx.importResultData.map((r) => r.name).join("，")), 1)
        ])
      ]),
      _: 1
    }, 8, ["visible", "confirm-loading", "onOk"])
  ], 64))
}